import React, { createContext, useCallback, useContext, useMemo, useReducer } from 'react';

export const EmailStateContext = createContext(null);

const emailReducer = (state, action) => {
  switch (action.type) {
    case 'SET_KEY':
      return {
        ...state,
        [action.parameter]: action.value,
      };
    case 'SET_STATE':
      return typeof action.value === 'function' ? action.value(state) : action.value;
    default:
      return state;
  }
};

const getInitialEmailComponentState = (initialCrmEmailState) => ({
  currentEmailDetails: initialCrmEmailState(),
  emailStateAfterSave: initialCrmEmailState(),
  emailStateAfterSavePreviewMode: {},
  emailSelectedContacts: [],
  activeTabEmailSent: 'Email',
  engagementStatisticsResult: [],
  emailPerformanceResult: [],
  emailPerformanceOnLoad: true,
  showSendPreviewPopUp: false,
  mailMergeModalIsOpen: false,
  isRemoveMailMergeDataModalOpen: false,
  remainingEmailCampaigns: { remainingCampaigns: null, isReady: false },
  // NOTE: we keep only email-component related keys here.
});

export const EmailStateProvider = ({ children, initialCrmEmailState }) => {
  const initialState = useMemo(() => getInitialEmailComponentState(initialCrmEmailState), [initialCrmEmailState]);
  const [emailState, dispatch] = useReducer(emailReducer, initialState);

  const setEmailState = useCallback(
    (parameterOrUpdater, value) => {
      if (typeof parameterOrUpdater === 'function') {
        dispatch({
          type: 'SET_STATE',
          value: parameterOrUpdater,
        });
        return;
      }

      dispatch({
        type: 'SET_KEY',
        parameter: parameterOrUpdater,
        value,
      });
    },
    []
  );

  const ctxValue = useMemo(() => ({ emailState, setEmailState }), [emailState, setEmailState]);

  return <EmailStateContext.Provider value={ctxValue}>{children}</EmailStateContext.Provider>;
};

export const useEmailState = () => {
  const ctx = useContext(EmailStateContext);
  if (!ctx) throw new Error('useEmailState must be used within an EmailStateProvider');
  return ctx;
};

